module.exports = __webpack_public_path__ + "static/hero_2-e959650d2451530b69c03ceb66f24a61.png";